/**
 * Пилюля голоса персонажа — только ▶, проба по нажатию; названия голоса на ней нет (владелец 08.10: «заменим имя
 * на аватарку, при наведении — развёрнутая принадлежность, как в верхнем баре»). Чей голос и какой — в подсказке
 * при наведении, как у чипа звука композера: «Голос: Лира — Elen Kuragina · зрелый · для рассказов». Одна на пикер
 * персонажей, список стопки и окно звука; место и размер задаёт вызывающий (className — пилюле, wrapClassName —
 * обёртке подсказки, когда пилюлю надо позиционировать).
 */
import type { MouseEvent } from 'react'
import { Mic, MicOff } from 'lucide-react'
import type { VoiceCard } from '../../api/voiceCatalog'
import { voiceTip } from '../../utils/voiceCard'
import SideTooltip from '../SideTooltip'
import { BusyGlyph, PlayGlyph } from './CharacterVoicePicker'
import type { useVoiceProbe } from './useVoiceProbe'

export type VoiceProbe = ReturnType<typeof useVoiceProbe>

export default function VoiceProbePill({ voice, characterId, characterName, probe, className = 'scene-pick__voice', wrapClassName }: {
	voice: VoiceCard | null | undefined
	characterId: string
	/** Имя персонажа — чей это голос (в подсказке). */
	characterName?: string | null
	probe: VoiceProbe
	className?: string
	wrapClassName?: string
}) {
	if (!voice) {
		return (
			<SideTooltip text={`${characterName ? `${characterName}: голос` : 'Голос'} не задан — задаётся на странице аватара`} className={wrapClassName}>
				<span className={`${className} is-none is-compact`} role="img" aria-label="Без голоса"><MicOff size={12} aria-hidden="true" /></span>
			</SideTooltip>
		)
	}
	const key = `${characterId}:${voice.id}`
	const isPlaying = probe.playing === key
	const isBusy = probe.loading === key
	return (
		<SideTooltip text={voiceTip(voice, characterName)} className={wrapClassName}>
			<button type="button" className={`${className} is-compact${isPlaying ? ' is-playing' : ''}${isBusy ? ' is-busy' : ''}`} disabled={!voice.preview_url || isBusy}
				aria-busy={isBusy}
				aria-label={isPlaying ? `Остановить пробу голоса ${voice.name}` : `Прослушать голос ${voice.name}`}
				onClick={(e: MouseEvent) => { e.stopPropagation(); void probe.play(voice, key, characterId) }}>
				{voice.preview_url ? (isBusy ? <BusyGlyph /> : <PlayGlyph playing={isPlaying} />) : <Mic size={12} aria-hidden="true" />}
			</button>
		</SideTooltip>
	)
}
